import { FeatureFlagsContextType } from "@/modules/common/context/feature-flags.types";

export const FeatureFlagsKeys = {
  OLD_LEAD_PAGE: "old-lead-page",
  BLOCK_LEADS_FEATURE: "block-leads-feature",
  SSE_IN_CALL_INDICATOR: "sse_in_call_indicator",
} as const;

export type FeatureFlagKey =
  (typeof FeatureFlagsKeys)[keyof typeof FeatureFlagsKeys];

export const FEATURE_FLAGS_INITIAL_STATE: FeatureFlagsContextType = {
  flags: {},
  hasFlag: () => false,
};
